export default "__VITE_ASSET__BsJV5rnN__"